import axios from "axios";
import { useMutation } from "@tanstack/react-query";

interface PatientStatusRequest {
  requestId: string;
  ptName: string;
  ptResRegNo: string;
  hasGd?: boolean;
  gdRelation?: string;
  chiefComplaints: string[];
  preKtas: number;
  vsSbp: number;
  vsDbp: number;
  vsBpm: number;
  vsRr: number;
  vsTemperature: number;
  vsSpo2: number;
  vsBloodSugar: number;
  vsAvpu: "A" | "V" | "P" | "U";
  ecg?: string;
}

const postPatientStatus = async (data: PatientStatusRequest) => {
  const response = await axios.post(
    "/api/v1/transfer/requests/patientStatus",
    data
  );
  return response.data;
};

export const usePostPatientStatus = () => {
  const { mutate } = usePostHospitalRankings();

  return useMutation({
    mutationFn: postPatientStatus,
    onSuccess(data) {
      console.log(data.result.data);
      mutate({
        requestId: data.result.data,
        hospitals: exampleHospitals,
      });
    },
  });
};

const getRandomNumber = (): number => {
  return Math.floor(Math.random() * 1000) + 1;
};

const getRandomFourDigitString = (num: number): string => {
  return num.toString().padStart(4, "0");
};

const names = [
  "김덕배",
  "김춘자",
  "홍길동",
  "정창수",
  "고길동",
  // "감친수",
  "신형만",
  // "유자춘",
];

// 예시 사용
export const examplePatientStatus: PatientStatusRequest = {
  requestId: `REQ-20250513${getRandomFourDigitString(getRandomNumber())}`,
  ptName: names[getRandomNumber() % names.length],
  ptResRegNo: `600101-123${getRandomFourDigitString(getRandomNumber())}`,
  hasGd: true,
  gdRelation: "배우자",
  chiefComplaints: ["R07"],
  preKtas: 2,
  vsSbp: 100,
  vsDbp: 20,
  vsBpm: 110,
  vsRr: 20,
  vsTemperature: 37.0,
  vsSpo2: 92,
  vsBloodSugar: 110,
  vsAvpu: "U",
  ecg: "STEMI",
};

// 사용 예시
// const mutation = usePostPatientStatus();
// mutation.mutate(examplePatientStatus);

interface HospitalRanking {
  hospitalCode: string;
  ranking: number;
}

const postHospitalRankings = async ({
  requestId,
  hospitals,
}: {
  requestId: string;
  hospitals: HospitalRanking[];
}) => {
  const response = await axios.post(
    `/api/v1/transfer/requests/${requestId}/hospitals`,
    hospitals
  );
  return response.data;
};

export const usePostHospitalRankings = () => {
  return useMutation({
    mutationFn: postHospitalRankings,
  });
};

// 사용 예시
const exampleHospitals: HospitalRanking[] = [
  { hospitalCode: "A1300001", ranking: 1 },
  { hospitalCode: "A1300002", ranking: 2 },
  { hospitalCode: "A1300003", ranking: 3 },
  { hospitalCode: "A1300004", ranking: 4 },
  { hospitalCode: "A1300007", ranking: 5 },
  { hospitalCode: "A1300010", ranking: 6 },
];
